module.exports = __webpack_public_path__ + "static/media/handbags_hero_desktop.cfe509af.jpg";